import { collection, limit, onSnapshot, orderBy, query } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { COL, type Rating } from '@eprintsmart/shared';
import { db } from '../firebase';

/** Ratings of people, from the staff side. */

const fns = () => getFunctions(undefined, 'asia-south1');

export function watchRatings(cb: (rows: Rating[]) => void, max = 200): () => void {
  return onSnapshot(
    query(collection(db, COL.ratings), orderBy('createdAt', 'desc'), limit(max)),
    (snap) => cb(snap.docs.map((d) => ({ ...(d.data() as Rating), id: d.id }))),
  );
}

/**
 * Takes an abusive rating down, or puts one back.
 *
 * A reason is mandatory at the callable, not just here. IS 19000:2022's
 * principle is no selective publication — removal is for personal attacks and
 * content that identifies somebody, never for a score that drags an average
 * down. The row is marked rather than deleted and the count is unchanged.
 */
export async function moderateRating(payload: {
  ratingId: string;
  action: 'REMOVE' | 'RESTORE';
  reason: string;
}): Promise<void> {
  await httpsCallable(fns(), 'moderateRating')(payload);
}
